// src/conversion-analytics.ts
var CAEventType = {
  SESSION_CONFIG: "session-config",
  SESSION_DATA: "session-data",
  STEP_SHOWN: "step-shown",
  DATA_SHOWN: "data-shown",
  STEP_SUBMITTED: "data-selected",
  APPOINTMENT_REQUESTED: "appointment-requested",
  APPOINTMENT_CONFIRMED: "appointment-confirmed",
  TIMETABLE_NAVIGATION: "timetable-navigation"
};

// src/event-types.ts
var PluginEvent = {
  CREATION: "CREATION",
  ERROR: "ERROR",
  INIT: "INIT",
  LOADED: "LOADED",
  MISCONFIGURED: "MISCONFIGURED",
  APPOINTMENT_CANCELLED: "APPOINTMENT_CANCELLED",
  APPOINTMENT_COMPLETED: "APPOINTMENT_COMPLETED",
  APPOINTMENT_CREATED: "APPOINTMENT_CREATED",
  APPOINTMENT_EDITED: "APPOINTMENT_EDITED",
  INVITE_ACCEPTED: "INVITE_ACCEPTED",
  STEP_SHOWN: "STEP_SHOWN"
};
var RequestEvent = {
  PRE_APPOINTMENT_REQUEST: "PRE_APPOINTMENT_REQUEST",
  REQUEST_GEOLOCATION: "REQUEST_GEOLOCATION",
  REQUEST_ORIGIN_URL: "REQUEST_ORIGIN_URL",
  CSS_VAR_UPDATE: "CSS_VAR_UPDATE",
  CUSTOM_CSS_UPDATE: "CUSTOM_CSS_UPDATE"
};
var PluginMisconfigured = {
  EMPLOYEE_ID: "EMPLOYEE_ID",
  CLIENT_ID: "CLIENT_ID",
  CONTACT_HINTS: "CONTACT_HINTS",
  GEOLOCATION: "GEOLOCATION",
  INTENT_WITHOUT_RESOURCE_CODE: "INTENT_WITHOUT_RESOURCE_CODE",
  INVALID_FLOW: "INVALID_FLOW",
  INVALID_INTENT: "INVALID_INTENT",
  INVALID_RESOURCE_CODE: "INVALID_RESOURCE_CODE",
  LISTING_ID: "LISTING_ID",
  MEETING_TYPE: "MEETING_TYPE",
  OFFICE_ID: "OFFICE_ID",
  RESOURCE_CODE: "RESOURCE_CODE",
  SUBJECT_ID: "SUBJECT_ID",
  TIMEZONE: "TIMEZONE"
};
var PluginError = {
  API_DOWN: "API_DOWN",
  RECAPTCHA_SCRIPT_LOAD: "RECAPTCHA_SCRIPT_LOAD",
  SUB_DATE_INTERPOLATION: "SUB_DATE_INTERPOLATION",
  TRANSLATION: "TRANSLATION"
};
export {
  CAEventType,
  PluginError,
  PluginEvent,
  PluginMisconfigured,
  RequestEvent
};
